import React from "react";
import { Autocomplete, Checkbox, Grid, TextField, Typography } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const iconoBlank = <CheckBoxOutlineBlankIcon fontSize="small" />;
const iconoCheck = <CheckBoxIcon fontSize="small" />;

function SelectorCategorias({
  sucursales,
  productos,
  tiposCliente,
  sucursalesSeleccionadas,
  setSucursalesSeleccionadas,
  productosSeleccionados,
  setProductosSeleccionados,
  tiposSeleccionados,
  setTiposSeleccionados,
}) {
  return (
    <Grid container spacing={2} mt={0.5}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">
          Seleccione sucursales, productos y tipos de cliente a actualizar
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          size="small"
          options={sucursales}
          getOptionLabel={(o) => o.nombre ?? ""}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          value={sucursalesSeleccionadas}
          onChange={(_, value) => setSucursalesSeleccionadas(value)}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.id}>
              <Checkbox
                icon={iconoBlank}
                checkedIcon={iconoCheck}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nombre}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Sucursales" placeholder="Buscar..." />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          size="small"
          options={productos}
          getOptionLabel={(o) => o.nombre ?? ""}
          isOptionEqualToValue={(o, v) => o.idproducto === v.idproducto}
          value={productosSeleccionados}
          onChange={(_, value) => setProductosSeleccionados(value)}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.idproducto}>
              <Checkbox
                icon={iconoBlank}
                checkedIcon={iconoCheck}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nombre}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Productos" placeholder="Buscar..." />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          size="small"
          options={tiposCliente}
          getOptionLabel={(o) => o.descripcion ?? ""}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          value={tiposSeleccionados}
          onChange={(_, value) => setTiposSeleccionados(value)}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.id}>
              <Checkbox
                icon={iconoBlank}
                checkedIcon={iconoCheck}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.descripcion}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tipos de Cliente"
              placeholder="Buscar..."
            />
          )}
        />
      </Grid>
    </Grid>
  );
}

export default SelectorCategorias;
